const propertyTypes = [
  { id: "-1", name: "Please select property type" },
  { id: "1", name: "Rural" },
  { id: "2", name: "Commercial" },
  { id: "3", name: "Industrial" },
  { id: "4", name: "Residential" },
];

export default propertyTypes;
